import React from 'react';
import { Row } from 'react-bootstrap';
import { FormFilterCard, FormCol } from 'motion-components';
import * as Yup from 'yup';
import { SelectYear } from '../../components/select-year';
import { useTranslation } from 'react-i18next';
import { splitGmtFromDate } from 'motion-components';
import { useRootStore } from 'store';
import { FieldSelectCollector, FieldSelectWasteReceptionPoint } from 'shared-pages/components';
import { IdocWasteDestinationTypes } from 'shared-pages/shared/constants';

/* ----------- Filters ------------------ */
export const Filters = ({ onChange, initialValues, wasteDestinationTypeId }) => {
  const { appStore } = useRootStore();
  const { t } = useTranslation();
  function handleFiltersSubmit(values, { setSubmitting }) {
    setTimeout(() => {
      setSubmitting(false);
      const startDate = new Date(values.year, 0, 1);
      const endDate = new Date(values.year, 11, 31, 23, 59, 59);
      onChange({
        startDate: splitGmtFromDate(startDate),
        endDate: splitGmtFromDate(endDate),
        wasteDestinationTypeId,
        collectorId: values.collectorId,
        wastereceptionpointId: values.wastereceptionpointId,
      });
    }, 400);
  }

  const filters = {
    //month: initialValues?.month ?? undefined,
    year: initialValues?.year ?? new Date().getFullYear(),
    //wasteDestinationTypeId: initialValues?.wasteDestinationTypeId ?? undefined,
    collectorId: initialValues?.collectorId ?? undefined,
  };

  const formShape = {
    year: Yup.string().required('Το Έτος είναι υποχρεωτικό'),
    collectorId: Yup.number().nullable(),
  };

  const validationSchema = Yup.object().shape(formShape);
  return (
    <FormFilterCard
      title={t('Κριτήρια Αναζήτησης')}
      onSubmit={handleFiltersSubmit}
      initialValues={filters}
      validationSchema={validationSchema}
    >
      <Row>
        <SelectYear name="year" title="Έτος" required={true} as={FormCol} />

        {appStore.isPlatformOwner && (
          <FieldSelectCollector as={FormCol} name="collectorId" label={t('Συλλέκτης')} />
        )}
        <FieldSelectWasteReceptionPoint
          as={FormCol}
          name="wastereceptionpointId"
          onlySecondaryStorage={
            wasteDestinationTypeId === IdocWasteDestinationTypes.SecondaryStorage
          }
          onlyRecyclers={wasteDestinationTypeId === IdocWasteDestinationTypes.Recycling}
        />
      </Row>
    </FormFilterCard>
  );
};
